import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const FormikPasswordField = ({ form, field, error, parse, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  console.log("Password field", field, rest);
  error = "";
  if (form.errors[field.name] && form.touched[field.name]) {
    console.log("Error", form.errors, form.touched);
    error = form.errors[field.name];
  }

  const _onChange = (e) => {
    let value = e.target.value;
    if (parse) {
      value = parse(value);
    }
    form.setFieldValue(field.name, value);
  };

  return (
    <TextField
      margin="normal"
      fullWidth={true}
      error={!!error}
      helperText={error}
      {...field}
      onChange={_onChange}
      {...rest}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FormikPasswordField;
